import ApiService from './api.service'

const SponsorService = {
  index (search = '', page = 1) {
    return ApiService.get(`api/v1/admin/sponsors?search=${search}&page=${page}`)
  },

  show (uuid) {
    return ApiService.get('api/v1/admin/sponsors/' + uuid)
  },

  update (uuid, data) {
    return ApiService.put('api/v1/admin/sponsors/' + uuid, data)
  },

  store (data) {
    return ApiService.post('api/v1/admin/sponsors', data)
  }
}

export default SponsorService
